/**************************************************
 * Nombre:       Tarjeta_Formacion_Item
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Formacion_Item = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 2, sm: 12, md: 1}} sx={{justifyContent: 'flex-start'}}>
                    <img src={item.img} width={30} height="auto"/>
                </Grid>

                <Grid container size={{xs: 10, sm: 12, md: 10}} sx={{justifyContent: 'flex-start',pl:sCell ? 1 : 2}}>
                    <Typography sx={{fontSize:sCell ? 12 : 14, fontWeight: 400, lineHeight: 1.2}}>{item.nombre}</Typography>
                </Grid>

            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt:1}}>
                <Typography
                    sx={{
                        fontSize: sCell ? 24 : 28,
                        fontWeight: 600,
                        color: theme.palette.primary.main,
                        fontFamily: NEGRITA,
                        lineHeight: 1.1
                    }}>
                    {item.descripcion}
                </Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Formacion_Item